import { render } from "./BaseInputIVR.vue?vue&type=template&id=4cb946be&scoped=true"
import script from "./BaseInputIVR.vue?vue&type=script&lang=js"
export * from "./BaseInputIVR.vue?vue&type=script&lang=js"

import "./BaseInputIVR.vue?vue&type=style&index=0&id=4cb946be&scoped=true&lang=css"

import exportComponent from "E:\\GCM3\\Demo\\demo-legacy-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4cb946be"]])

export default __exports__